
import { PropType, defineComponent } from 'vue';
import { CollectionsAgency } from '@/interfaces/loan';

export default defineComponent({
  name: 'CollectionAgencyContact',

  props: {
    agency: { type: Object as PropType<CollectionsAgency>, required: true },
  }
});
